import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { AnalyticsData } from '../../../../pages/Analytics';
import useI18n from '../../../../hooks/useI18n';
import { translateChartLabels } from '../../../../utils/dateTimeTranslations';

interface ApexColumnChartProps {
  timeFrameView: AnalyticsData['timeFrameView'];
  view?: 'daily' | 'weekly' | 'monthly' | 'yearly';
}

const ApexColumnChart: React.FC<ApexColumnChartProps> = ({
  timeFrameView,
  view = 'weekly',
}) => {
  const { t, currentLanguage } = useI18n();
  const [series, setSeries] = useState([
    { name: String(t('analytics.clicks')), data: [] as number[] },
  ]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const data = timeFrameView.map(({ count }) => count);
    const originalLabels = timeFrameView.map(({ _id }) => _id);

    const translatedLabels = translateChartLabels(
      originalLabels,
      view,
      currentLanguage,
    );

    setSeries([{ name: String(t('analytics.clicks')), data }]);
    setCategories(translatedLabels);
  }, [timeFrameView, t, currentLanguage, view]);

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: window.innerWidth < 768 ? 15 : 20,
        borderRadius: window.innerWidth < 768 ? 7 : 9,
      },
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        },
      },
      active: {
        filter: {
          type: 'none',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: categories,
      labels: {
        show: true,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: true,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    grid: {
      show: true,
      borderColor: '#E3CCF4',
      strokeDashArray: 4,
    },
    fill: {
      colors: ['#E3CCF4'],
      opacity: 1,
      type: 'solid',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        shadeIntensity: 0.5,
        opacityFrom: 1,
        opacityTo: 1,
      },
    },
    tooltip: {
      enabled: true,
    },
  };

  return (
    // <div className="w-full h-[100%] max-h-[550px] md:max-h-[350px] pb-2 border border-green-500">
    <div
      className="w-full"
      style={{ maxHeight: '60vh', height: '100%', position: 'relative' }}
    >
      <div style={{ width: '100%', height: '100%' }}>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height="350"
        />
      </div>
    </div>
  );
};

export default ApexColumnChart;
